import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Icon } from '@salesforce/design-system-react';
import { socket } from '../../socket';

import CollaboratorModal from '../../Components/Entry/CollaboratorModal';
import SocketListeners from '../../Components/App/SocketListeners';

import {
  addActiveCollaborator,
  addingActiveCollab,
  addToast,
  searchCollaborators,
  addJourneyCollaborators
} from '../../actions';


function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  const toggle = React.useCallback(() => {
    setValue(v => !v);
  }, []);

  return [value, toggle];
}

const ActiveCollaborators = (props) => { 
  const [isOpen, toggleIsOpen] = useToggle();


  useEffect(() => { 
    socket.emit('onLoadServer', props.journeyId); // Adds to room.
    console.log('onLoadServer ActiveCollab');
    //socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);


  const addCollaborators = async (collaboratorInfo) => {
    if (!Number.isNaN(parseInt(collaboratorInfo.journeyId))) {
      await props.addJourneyCollaborators(
        collaboratorInfo.collaborators,
        collaboratorInfo.journeyId,
        collaboratorInfo.pillOptions
      );
      
      toggleIsOpen();
    }
  };

  return (
      <div>
        <div className="slds-p-around_xx-small slds-grid">
          <div className="slds-text-title_caps slds-size_3-of-12 slds-align_absolute-center">
            Active
          </div>
          <SocketListeners></SocketListeners>
          <ul className="slds-size_9-of-12 slds-p-around_small">
            {Object.keys(props.activeCollaborators).map((id) => {
              if(id < 5) {
                return (
                  <li
                    className="slds-p-vertical_xx-small slds-p-horizontal_x-small "
                    style={{ display: 'inline', height: '25px', width: '25px', backgroundColor: '#032D60', color: 'white', borderRadius: '50%', fontWeight: '600', border: '2px solid white'}}
                    title={props.activeCollaborators[id]}
                  >
                    {props.activeCollaborators[id].charAt(0).toUpperCase()}
                  </li>
                )
              }
            })}
            <li
              style={{ 
                  display: 'inline', 
                  backgroundColor: 'white', 
                  borderRadius: '50%', 
                  border: '1px solid #032D60',
                  cursor: 'pointer',
                  padding: '.2rem .25rem .25rem .25rem'
              }}
              onClick={toggleIsOpen}
              title="Add Collaborator"
            >
              <Icon category="utility" name="add" size="x-small" style={{ fill: '#032D60'}} />
            </li>
          </ul>
        </div>

        <Modal
          isOpen={isOpen}
          onRequestClose={toggleIsOpen}
          heading="Add Collaborators"
        >
          <CollaboratorModal
            journeyId={props.journeyId}
            journeyEmail={props.username}
            isLoadingCollaborator={props.isLoadingSearchedCollaborators}
            onCollaboratorsChange={(e) => props.searchCollaborators(e)}
            collaborator={props.searchedCollaborators || []}
            onSubmit={(e) => addCollaborators(e)}
          />
          
        </Modal>
      </div>
  );
}

const mapStateToProps = (state) => ({
    activeCollaborators: state.collaborators.activeCollaborators,
    isLoadingSearchedCollaborators: state.app.isLoadingSearchedCollaborators,
    journeyId: state.app.journeyId,
    username: state.app.username,
    searchedCollaborators: state.collaborators.collaborators.map(
      (collaborator) => {
        return {
          label: collaborator.name,
          id: collaborator.id,
          subTitle: collaborator.email,
          value: collaborator.id,
        };
      }
    ),
  });

const mapDispatchToProps = (dispatch) => ({
    addActiveCollaborator : (email) =>
      dispatch(addActiveCollaborator(email)),
    addingActiveCollab : (activeCollaborators) =>
      dispatch(addingActiveCollab(activeCollaborators)),
    addToast: (toast) => dispatch(addToast(toast)),
    searchCollaborators: (term) => dispatch(searchCollaborators(term)),
    addJourneyCollaborators: (searchedCollaborators, journeyId, pillOptions) =>
    dispatch(
      addJourneyCollaborators(searchedCollaborators, journeyId, pillOptions)
    ),
});
  
  export default connect(mapStateToProps, mapDispatchToProps)(ActiveCollaborators);